import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Capitalizes the first letter of each whitespace-separated word.
 * Unicode-aware: handles diacritics and non-ASCII characters correctly.
 */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str.replace(/\S+/gu, (word) =>
    word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
  );
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
